<template>
  <header
    class="the-header"
    :class="[
      headerClass,
      { 'supplier dark-theme': supplierStyle },
      { 'supplier-1': isSupplier },
      { 'md:px-5': isSuppliersIndexPage },
      { transparent: transparentStyle },
      { 'temp-supplier-three-home': supplierThreeStyle },
      { 'temp-supplier-three': isSupplierThree },
      { 'temp-supplier-four-home': supplierFourStyle },
      { 'temp-supplier-four': isSupplierFour },
      { 'temp-supplier-four': isSupplierFive },
      { '!shadow-none !bg-transparent': supplierFiveStyle },
      { 'template4-home': template4Style },
      { 'template2-home': template2Style },
      { template4: isTemplate4 },
      { scrolled: isScrolled },
    ]"
  >
    <div
      class="container addition-layout-padding h-full"
      :class="{ 'addition-layout-padding': hasAdditionalPadding }"
      v-show="isReady"
    >
      <div class="main-menu">
        <div
          v-if="hasCenteredLogoWrap"
          class="hidden lg:flex justify-center items-center"
          style="width: 190px"
        >
          <NuxtLink
            class="logo"
            :class="
              headerData.logoHeightSize ? headerData.logoHeightSize : 'h-[36px]'
            "
            :to="localePath('/')"
          >
            <NuxtImg
              loading="lazy"
              v-no-right-click
              :src="
                (supplierStyle && headerData.logoDarkMode) ||
                (supplierThreeStyle && headerData.logoDarkMode) ||
                (supplierFourStyle && headerData.logoDarkMode) ||
                (supplierFiveStyle && headerData.logoDarkMode) ||
                (template4Style && headerData.logoDarkMode) ||
                (transparentStyle && headerData.logoDarkMode)
                  ? headerData.logoDarkMode
                  : headerData.logo
              "
              alt="logo"
            />
          </NuxtLink>
        </div>
        <NuxtLink
          v-else
          class="logo hidden lg:block"
          :class="
            headerData.logoHeightSize ? headerData.logoHeightSize : 'h-[36px]'
          "
          :to="localePath('/')"
        >
          <NuxtImg
            loading="lazy"
            v-no-right-click
            :src="
              (supplierStyle && headerData.logoDarkMode) ||
              (supplierThreeStyle && headerData.logoDarkMode) ||
              (supplierFourStyle && headerData.logoDarkMode) ||
              (supplierFiveStyle && headerData.logoDarkMode) ||
              (template4Style && headerData.logoDarkMode) ||
              (transparentStyle && headerData.logoDarkMode)
                ? headerData.logoDarkMode
                : headerData.logo
            "
            alt="logo"
          />
        </NuxtLink>
        <NuxtLink
          class="logo inline-flex lg:hidden h-[52px]"
          :to="localePath('/')"
        >
          <NuxtImg
            loading="lazy"
            v-no-right-click
            :src="
              (template4Style && headerData.logoDarkMode) ||
              (transparentStyle && headerData.logoDarkMode) ||
              (supplierFourStyle && headerData.logoDarkMode) ||
              (supplierFiveStyle && headerData.logoDarkMode)
                ? headerData.logoDarkMode
                : headerData.mobileLogo
            "
            alt="logo"
          />
        </NuxtLink>
        <SearchBoxTwoSupplier
          v-if="
            headerData.hasSearchBar && headerData.searchBarType == 'supplier'
          "
          :is-box="false"
          :just-icon="true"
          class="lg:!hidden w-4/6"
        />
        <SearchBoxOneFour
          v-else-if="headerData.hasSearchBar"
          :top-cities="topCities!"
          :is-box="false"
          :just-icon="true"
          class="lg:!hidden w-4/6"
        />
        <Menu
          class="!hidden lg:!flex"
          :header-data="headerData"
          :currencies-list="currenciesList!"
          :top-cities="topCities!"
          :is-supplier="isSupplier"
          :route-path="routePath"
          :search-box-is-box="searchBoxIsBox"
          :elfsight-form="elfsightForm"
          :is-scrolled="isScrolled"
          @open-elfsight-form="showElfsightForm = true"
          @open-login="emit('open-login', $event)"
        />
        <div class="flex lg:hidden">
          <TheHeaderSwitcher
            v-if="
              headerData.langSwitchMobileNav &&
              headerData.isMultiLanguage &&
              checkMultiLang
            "
            show-bottom-sheet
            :active-item="getActiveLang"
            :show-code="false"
            :list="availableLocales"
            :header-data="headerData"
            is-centered
            :route-path="routePath"
            :is-scrolled="isScrolled"
            @update:active-item="switchLanguage"
          />
          <Cart
            class="lg:hidden ms-4"
            :is-scrolled="isScrolled"
            @open-login="emit('open-login', $event)"
          />
          <button
            class="menu-button icon ms-4"
            @click="modalStatus = true"
            aria-label="toggle"
          >
            <icon-hamburger />
          </button>
          <BaseBottomSheet v-model:show="modalStatus" :full-height="true">
            <Menu
              class="mt-3"
              :header-data="headerData"
              :currencies-list="currenciesList ?? []"
              :top-cities="topCities ?? []"
              :is-supplier="isSupplier"
              :search-box-is-box="true"
              :route-path="routePath"
              :elfsight-form="elfsightForm"
              :is-scrolled="true"
              @open-elfsight-form="showElfsightForm = true"
              @open-login="emit('open-login', $event)"
            />
          </BaseBottomSheet>
        </div>
      </div>
    </div>
    <BaseSimpleModal
      custom-class="!w-[554px] h-full !bg-body-bg !p-2 md:!p-4 !mx-2.5"
      close-btn-class="text-white m-2 text-[27px]"
      v-model:modal-show="showElfsightForm"
    >
      <template #content>
        <div :class="`${elfsightForm}`" data-elfsight-app-lazy></div>
      </template>
    </BaseSimpleModal>
  </header>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { useAsyncData, useRuntimeConfig } from "nuxt/app";
import type { ICurrency, ITopCities } from "../../../types/general";
import Menu from "./TheHeaderMenu.vue";
import SearchBoxOneFour from "../../search-box/SearchBoxOneFour.vue";
import SearchBoxTwoSupplier from "../../search-box/SearchBoxTwoSupplier.vue";
import customFetch from "../../../composables/customFetch";
import TheHeaderSwitcher from "./TheHeaderSwitcher.vue";

const localePath = useLocalePath();
const config = useRuntimeConfig() as unknown as RuntimeConfiguration;
const emit = defineEmits(["open-login"]);
const props = defineProps({
  headerClass: { type: String, default: null },
  routePath: { type: String, default: "/" },
  isSupplier: { type: Boolean, default: false },
  isSupplierThree: { type: Boolean, default: false },
  isSupplierFour: { type: Boolean, default: false },
  isSupplierFive: { type: Boolean, default: false },
  isTransparent: { type: Boolean, default: false },
  isTemplate4: { type: Boolean, default: false },
  isTemplate2: { type: Boolean, default: false },
  hasAdditionalPadding: { type: Boolean, default: true },
});

const { locales, setLocale, locale } = useI18n();
const activeLang = ref(locale.value);
// const activeLang = useCookie<string>("locale");

const modalStatus = ref<boolean>(false);
const configData = ref<RuntimeConfiguration>(config);
const isScrolled = ref<boolean>(false);
const isReady = ref<boolean>(false);

const headerData = configData.value.public.header;
const heroConfig = config.public.supplierStatic?.hero || null;
const hasCenteredLogoWrap = computed(
  () =>
    heroConfig?.heroTitleMargin === 190 &&
    heroConfig?.reverseSlogan === false &&
    heroConfig?.rectangle?.width === 164 &&
    heroConfig?.rectangle?.height === 316,
);
const elfsightForm = headerData.elfsightForm || null;
const showElfsightForm = ref<boolean>(false);

const [{ data: currenciesList }, { data: topCities }] = await Promise.all([
  useAsyncData<ICurrency[]>("currencies", () => customFetch(`api/currencies`)),
  useAsyncData<ITopCities[]>("top-cities", () => customFetch(`api/top-cities`)),
]);

watch(
  () => props.routePath,
  () => {
    checkScroll();
    modalStatus.value = false;
  },
);

const searchBoxIsBox = computed(() => {
  // Icon-only mode: keep the search bar collapsed and let the user open it
  // by clicking — never auto-expand it (e.g. on scroll).
  if (headerData.searchBarManualOpen) return false;
  return props.isSupplier || props.isSupplierFour
    ? false
    : props.routePath == localePath("/")
      ? isScrolled.value
      : true;
});

const supplierStyle = computed(() => {
  return isSuppliersIndexPage.value && !isScrolled.value;
});
const supplierThreeStyle = computed(() => {
  return isSupplierThreeIndexPage.value && !isScrolled.value;
});
const supplierFourStyle = computed(() => {
  return isSupplierFourIndexPage.value && !isScrolled.value;
});
const supplierFiveStyle = computed(() => {
  return isSupplierFiveIndexPage.value && !isScrolled.value;
});
const transparentStyle = computed(() => {
  return isTransparentIndexPage.value && !isScrolled.value;
});
const template4Style = computed(() => {
  return isTemplate4IndexPage.value && !isScrolled.value;
});
const template2Style = computed(() => {
  return isTemplate2IndexPage.value && !isScrolled.value;
});

const isSuppliersIndexPage = computed(() => {
  return props.isSupplier && props.routePath == localePath("/");
});
const isSupplierThreeIndexPage = computed(() => {
  return props.isSupplierThree && props.routePath == localePath("/");
});
const isSupplierFourIndexPage = computed(() => {
  return props.isSupplierFour && props.routePath == localePath("/");
});
const isSupplierFiveIndexPage = computed(() => {
  return props.isSupplierFive && props.routePath == localePath("/");
});
const isTransparentIndexPage = computed(() => {
  return props.isTransparent && props.routePath == localePath("/");
});
const isTemplate4IndexPage = computed(() => {
  return props.isTemplate4 && props.routePath == localePath("/");
});
const isTemplate2IndexPage = computed(() => {
  return props.isTemplate2 && props.routePath == localePath("/");
});

const checkMultiLang = computed(() => {
  return locales.value && locales.value.length > 1;
});

const getActiveLang = computed(() => {
  return activeLang.value || "";
});

const availableLocales = computed(() => {
  return locales.value;
});

const switchLanguage = async (langCode: string) => {
  if (langCode !== locale.value) {
    activeLang.value = langCode;
    try {
      await setLocale(langCode);
    } catch (error) {
      console.error("Failed to switch language:", error);
      activeLang.value = locale.value;
    }
  }
};

const checkScroll = () => {
  isScrolled.value = isSuppliersIndexPage.value
    ? document.body.scrollTop > 150
    : isTemplate4IndexPage.value
      ? document.body.scrollTop > 40
      : document.body.scrollTop > 20;

  // props.isSupplier ||
  // props.isSupplierThree ||
  // props.isSupplierFour ||
  // props.isSupplierFive
  //   ? false
  //   : props.isTemplate4
  //     ? document.body.scrollTop > (document.body.clientHeight * 45) / 100
  //     : document.body.scrollTop > (document.body.clientHeight * 90) / 100;
};
onBeforeMount(() => {
  isReady.value = true;
});
onMounted(() => {
  isReady.value = true;
  document.body.addEventListener("scroll", checkScroll);
  if (
    !document.querySelector(
      'script[src="https://static.elfsight.com/platform/platform.js"]',
    )
  ) {
    const script = document.createElement("script");
    script.src = "https://static.elfsight.com/platform/platform.js";
    script.async = true;
    document.body.appendChild(script);
  }
});

onUnmounted(() => {
  document.body.removeEventListener("scroll", checkScroll);
});
</script>
